import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { tenantKey } from '@/lib/queryClient'
import { useTenant } from '@/hooks/useTenant'
import { plaidApi } from './api'

export function usePlaidConnections() {
  const tenantId = useTenant()
  return useQuery({
    queryKey: tenantKey(tenantId, 'plaid', 'connections'),
    queryFn: plaidApi.list,
  })
}

export function useDeletePlaidConnection() {
  const qc = useQueryClient()
  const tenantId = useTenant()
  return useMutation({
    mutationFn: plaidApi.deleteConnection,
    onSuccess: () => qc.invalidateQueries({ queryKey: tenantKey(tenantId, 'plaid', 'connections') }),
  })
}

export function useSchedulePlaid() {
  const qc = useQueryClient()
  const tenantId = useTenant()
  return useMutation({
    mutationFn: ({
      id,
      body,
    }: {
      id: number
      body: { value: number; unit: string; nextSyncISO: string }
    }) => plaidApi.schedule(id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: tenantKey(tenantId, 'plaid', 'connections') }),
  })
}
